import { FC } from "react";
import {
    Icon,
    IconProps,
    WhatsappThinOutlineIcon,
    TelegramOutlineIcon,
    MailThinOutlineIcon,
    FacebookThinOutlineIcon,
    InstagramThinOutlineIcon,
    TiktokThinOutlineIcon,
    LinkedinThinOutlineIcon,
    PhoneThinOutlineIcon,
    BubblesThinOutlineIcon,
} from "@smile2impress/components";

import { ContactTypes, SocialTypes } from "constants/enum";

export type SocialIconNameType = ContactTypes | SocialTypes;

const iconsByName = {
    [ContactTypes.PHONE]: PhoneThinOutlineIcon,
    [SocialTypes.WA]: WhatsappThinOutlineIcon,
    [SocialTypes.TG]: TelegramOutlineIcon,
    [ContactTypes.EMAIL]: MailThinOutlineIcon,
    [SocialTypes.FB]: FacebookThinOutlineIcon,
    [SocialTypes.INSTAGRAM]: InstagramThinOutlineIcon,
    [SocialTypes.TIKTOK]: TiktokThinOutlineIcon,
    [SocialTypes.LINKDIN]: LinkedinThinOutlineIcon,
    [SocialTypes.CHAT]: BubblesThinOutlineIcon,
};

interface SocialMediaIconProps extends IconProps {
    iconName: SocialIconNameType;
    _dark?: string | Record<string, any>;
}

export const SocialMediaIcon: FC<SocialMediaIconProps> = ({
    iconName,
    ...rest
}) => {
    return (
        <Icon
            sx={{
                // @TODOFIX before re-design icons in figma
                path: {
                    strokeWidth:
                        iconName === SocialTypes.WA ||
                        iconName === SocialTypes.INSTAGRAM ||
                        iconName === ContactTypes.EMAIL
                            ? 0
                            : "initial",
                },
                ...rest,
            }}
            as={iconsByName[iconName]}
        />
    );
};
